import { Drawer, Flex, Typography } from "antd";
import styles from "./custom-drawer.module.css";

export function CustomDrawer({
  title = "Custom Drawer",
  placement = "right",
  open = false,
  size = "large",
  width,
  loading = false,
  onClose,
  footer,
  children,
  icon,
  description,
  className,
  drawerStyles,
}) {
  return (
    <Drawer
      closable
      destroyOnClose
      styles={drawerStyles}
      title={
        <div className={styles["drawer-header"]}>
          <div className={styles["drawer-title"]}>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {icon ? (
                <img
                  src={icon}
                  alt="Certificate"
                  className={styles["drawer-header-icon"]}
                />
              ) : null}
              {title}
            </div>
            <Typography className={styles["drawer-title-description"]}>
              {description}
            </Typography>
          </div>
        </div>
      }
      width={width || "40vw"}
      placement={placement}
      open={open}
      size={size}
      loading={loading}
      footer={footer}
      onClose={onClose}
      className={className}
    >
      {children}
    </Drawer>
  );
}

export default CustomDrawer;
